var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',_vm._b({ref:"field",attrs:{"value":_vm.text,"placeholder":"0'0\"","rules":[_vm.validateDistance, ..._vm.parsedRules]},on:{"input":_vm.onInput,"blur":_vm.onBlur,"beforeinput":_vm.onBeforeInput,"keydown":_vm.onKeydown,"paste":_vm.onPaste}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }